import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import "./index.css"
import { bootstrapTheme } from "./hooks/useTheme"

// Aplica tema antes do React montar — evita flash de tema errado em 1ª visita
bootstrapTheme()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
